import { createContext, useContext } from 'react';
import { useTranslation } from 'react-i18next';

export type TranslationKeys = {
  application: string;
  services: string;
  payment: string;
};

export const TranslationKeysContext = createContext<TranslationKeys>({
  application: 'fillApplication',
  services: 'services',
  payment: 'payment',
});

export const useTranslationKeys = (): TranslationKeys => {
  const keys = useContext(TranslationKeysContext);
  return keys;
};

export const useTranslationContext = (key: keyof TranslationKeys) => {
  const keys = useTranslationKeys();
  return useTranslation(keys[key]);
};
